import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import petsService from '../../services/petsService';

const initialState = {
  pets: [],
  totalPets: 0,
  currentPage: 1,
  totalPages: 1,
  isLoading: false,
  error: null,
};

export const fetchPets = createAsyncThunk(
  'pets/fetchAll',
  async (params = {}, thunkAPI) => {
    try {
      return await petsService.getAll(params);
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to fetch pets';
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const petsSlice = createSlice({
  name: 'pets',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPets.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPets.fulfilled, (state, action) => {
        state.isLoading = false;
        const { pets = [], pagination = {} } = action.payload;
        state.pets = pets;
        state.totalPets = pagination.total || 0;
        state.currentPage = pagination.page || 1;
        state.totalPages = pagination.pages || 1;
      })
      .addCase(fetchPets.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = petsSlice.actions;
export default petsSlice.reducer;
